<template>
  <div>
    <v-container class="kpr-container">
      <v-form ref="generateReportForm" @submit.prevent="submit">

        <!-- ── TOP FILTER BAR ── -->
        <div class="kpr-filter-bar">
          <div class="kpr-filter-grid">
            <v-combobox
              autofocus
              label="Tip dokumenta *"
              v-model="docType"
              :items="documentTypes"
              outlined dense hide-details
              item-text="name"
              item-value="value"
              clearable
              :rules="[rules.req]"
              class="filter-select uppercased-input">
              <template v-slot:item="{ item, on, attrs }">
                <v-list-item class="uppercased-input" v-on="on" v-bind="attrs">{{ item.name }}</v-list-item>
              </template>
            </v-combobox>

            <v-menu v-model="totalFromMenu" offset-y :close-on-content-click="false"
              transition="scale-transition" max-width="290px" min-width="290px">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="formatFrom2"
                  label="Od datuma *"
                  :rules="[rules.req]"
                  outlined dense hide-details
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  class="filter-select"
                  v-bind="attrs" v-on="on">
                </v-text-field>
              </template>
              <v-date-picker v-model="from2" no-title scrollable :max="totalTo" locale="hr-HR" @input="totalFromMenu = false" />
            </v-menu>

            <v-menu v-model="totalToMenu" offset-y :close-on-content-click="false"
              transition="scale-transition" max-width="290px" min-width="290px">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="formatTo2"
                  label="Do datuma *"
                  :rules="[rules.req]"
                  outlined dense hide-details
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  class="filter-select"
                  v-bind="attrs" v-on="on">
                </v-text-field>
              </template>
              <v-date-picker v-model="to2" no-title scrollable locale="hr-HR" @input="totalToMenu = false" />
            </v-menu>
          </div>
        </div>

        <!-- ── FLOATING CARD ── -->
        <div class="kpr-card">

          <div class="kpr-section-title">I. Opći podaci o poreznom obvezniku</div>

          <v-row>
            <v-col cols="8">
              <v-text-field
                label="1. Naziv djelatnosti"
                v-model="activityNameType"
                outlined dense
                class="kpr-field">
              </v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                label="Šifra djelatnosti"
                v-model="activityCode"
                outlined dense
                class="kpr-field">
              </v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <v-text-field
                label="2. Ime i prezime poduzetnika / nositelja zajedničke djelatnosti"
                v-model="firstLast"
                outlined dense
                class="kpr-field">
              </v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <v-text-field
                label="3. Adresa prebivališta / uobičajenog boravišta"
                v-model="residenceAddress"
                outlined dense
                class="kpr-field">
              </v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <v-text-field
                label="4. OIB poduzetnika / nositelja zajedničke djelatnosti"
                v-model="oib"
                outlined dense
                class="kpr-field">
              </v-text-field>
            </v-col>
          </v-row>

          <div class="kpr-section-title">II. Podaci o poslovnoj jedinici</div>

          <v-row>
            <v-col>
              <v-text-field
                label="1. Naziv"
                v-model="locationName"
                outlined dense
                class="kpr-field">
              </v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <v-text-field
                label="2. Adresa"
                v-model="locationAddress"
                outlined dense
                class="kpr-field">
              </v-text-field>
            </v-col>
          </v-row>

          <div class="kpr-actions">
            <v-btn
              class="kpr-generate-btn"
              type="submit"
              :disabled="submitting"
              :loading="submitting"
              elevation="0">
              Generiraj izvještaj
            </v-btn>
          </div>

        </div>

      </v-form>

      <v-overlay v-show="loading" absolute z-index="10">
        <v-progress-circular indeterminate size="64" color="primary" />
      </v-overlay>
    </v-container>
  </div>
</template>
<script>
import applicationSettings from '@/mixins/applicationSettings'
import { df, auth } from '@/plugins/firebase'
import { v4 as uuidv4 } from 'uuid'
import state from '@/state'
import rules from '@/plugins/rules'

export default {
  name: 'Reports',
  mixins: [applicationSettings],
  inject: ['showMsgBox', 'showLoader', 'hideLoader'],
  components: {},
  data: function () {
    return {
      visible: false,
      lastVisible: '',
      submitting: false,
      loading: false,
      companies: [],
      company: undefined,
      oib: '',
      firstLast: '',
      residenceAddress: '',
      entrepreneurName: '',
      activityNameType: '',
      activityAddress: '',
      showKprForm: true,
      from1: new Date(1609459260000).toISOString().substr(0, 10),
      fromMenu1: false,
      from2: '',
      fromMenu2: false,
      from3: '',
      fromMenu3: false,
      to1: new Date().toISOString().substr(0, 10),
      toMenu1: false,
      to2: '',
      toMenu2: false,
      to3: '',
      toMenu3: false,
      totalFromMenu: false,
      totalFrom: new Date(1609455600000).toISOString().substr(0, 10),
      totalToMenu: false,
      totalTo: new Date(1897388318000).toISOString().substr(0, 10),
      form: '',
      docType: { name: 'PDF', value: 'pdf' },
      locationAddress: '',
      locationName: '',
      activityCode: '',
      currency: 'HRK',
      receipts: [],
      rules: {
        req: rules.req(),
        oib: rules.oib(),
        arrReq: rules.arrReq(),
        validPass: rules.validPass,
        money: rules.money()
      }
    }
  },
  mounted () {
    this.getKpr()
  },
  watch: {
    search () {
      this.lastVisible = ''
    }
  },
  computed: {
    documentTypes () {
      return [
        { name: 'PDF', value: 'pdf' },
        { name: 'XLSX', value: 'xlsx' }
      ]
    },
    formatFrom2 () {
      if (this.from2 !== '') {
        return new Intl.DateTimeFormat('hr-HR', {
          month: '2-digit',
          day: '2-digit',
          year: 'numeric'
        }).format(new Date(this.from2))
      } else {
        return ''
      }
    },
    formatTo2 () {
      if (this.to2 !== '') {
        return new Intl.DateTimeFormat('hr-HR', {
          month: '2-digit',
          day: '2-digit',
          year: 'numeric'
        }).format(new Date(this.to2))
      } else {
        return ''
      }
    },
    totalFrom__datetime () {
      return parseInt(
        (new Date(`${this.totalFrom}`).getTime() / 1000).toFixed(0)
      )
    },
    totalTo__datetime () {
      return parseInt(
        (new Date(`${this.totalTo}T23:59:00`).getTime() / 1000).toFixed(0)
      )
    },
    from1__datetime () {
      return parseInt(
        (new Date(`${this.from1}T00:00:00`).getTime() / 1000).toFixed(0)
      )
    },
    from2__datetime () {
      return parseInt(
        (new Date(`${this.from2}T00:00:00`).getTime() / 1000).toFixed(0)
      )
    },

    from3__datetime () {
      return parseInt(
        (new Date(`${this.from3}T00:00:00`).getTime() / 1000).toFixed(0)
      )
    },
    to1__datetime () {
      return parseInt(
        (new Date(`${this.to1}T00:00:00`).getTime() / 1000).toFixed(0)
      )
    },
    to2__datetime () {
      return parseInt(
        (new Date(`${this.to2}T00:00:00`).getTime() / 1000).toFixed(0)
      )
    },

    to3__datetime () {
      return parseInt(
        (new Date(`${this.to3}T00:00:00`).getTime() / 1000).toFixed(0)
      )
    },
    from2__datetimekpr () {
      return parseInt((new Date(`${this.from2}T00:01:01`) / 1000).toFixed(0))
    },
    to2__datetimekpr () {
      return parseInt((new Date(`${this.to2}T23:59:00`) / 1000).toFixed(0))
    }
  },
  methods: {
    async getKpr () {
      try {
        let query = df
          .collection('companies/')
          .where('id', '==', state.getCurrentCompany().id)
        query.get().then((snapshot) => {
          snapshot.forEach((doc) => {
            const company = doc.data()

            this.activityNameType = company.name
            this.residenceAddress =
              company.address +
              ', ' +
              company.zip_code +
              ' ' +
              company.city +
              ', ' +
              company.country
            this.oib = company.oib
          })
        })

        query = df
          .collection('locations/')
          .where('id', '==', state.getPointOfSale().id)
        query.get().then((snapshot) => {
          snapshot.forEach((doc) => {
            const location = doc.data()

            this.locationName = location.name
            this.locationAddress =
              location.address +
              ', ' +
              location.zip_code +
              ' ' +
              location.city +
              ', ' +
              location.country
          })
        })
      } catch (error) {
        this.showMsgBox({
          text: error || 'Internal error',
          actions: ['cancel'],
          cancelBtnText: 'OK',
          color: 'error'
        })
        // console.error(error)
      }
    },
    modifyItems () {},
    submit () {
      if (!this.$refs.generateReportForm.validate()) return

      this.showLoader()
      const payload = {
        action: {
          operation: 'get',
          entity: 'sales_form',
          params: {
            company_id: state.getCurrentCompany().id,
            date_from: this.from2__datetimekpr,
            date_to: this.to2__datetimekpr,
            document_type: this.docType.value,
            location_id: state.getPointOfSale().id,
            name_of_activity: this.activityNameType,
            activity_code: this.activityCode,
            residence_address: this.residenceAddress,
            entrepreneur_oib: this.oib,
            entrepreneur_name: this.firstLast
          }
        }
      }

      const reqId = uuidv4()

      df.doc(`request/${reqId}`)
        .set({
          user_id: `${auth.currentUser.uid}`,
          device_id: 'web',
          created: `${new Date().getTime()}`,
          type: 'document',
          payload: btoa(unescape(encodeURIComponent(JSON.stringify(payload))))
        })
        .catch(() => {
          this.hideLoader()
          this.showMsgBox({
            text: 'Greška prilikom spremanja podataka.',
            actions: ['cancel'],
            cancelBtnText: 'OK',
            color: 'error'
          })
        })
        .finally(() => {})
      const unsubscribe = df.doc(`response/${reqId}`).onSnapshot((doc) => {
        if (this.$refs && doc.data()) {
          this.hideLoader()
          unsubscribe()
          if (
            !doc.data().body ||
            !doc.data().body.document ||
            doc.data().body.document === ''
          ) {
            this.showMsgBox({
              text: this.$t('$vuetify.errors.nullReportReceipts'),
              actions: ['cancel'],
              cancelBtnText: this.$t('$vuetify.close'),
              color: 'error'
            })
            this.$emit('onFinish')
            return
          }

          let linkSource = ''
          let fileName = ''
          fileName = `report-kpr.${new Date().getTime()}`
          if (this.docType.value === 'pdf') {
            linkSource = `data:application/pdf;base64,${
              doc.data().body.document
            }`
            fileName = `${fileName}.pdf`
          }

          if (this.docType.value === 'xlsx') {
            linkSource = `data:application/vnd.ms-excel;base64,${
              doc.data().body.document
            }`
            fileName = `${fileName}.xlsx`
          }

          const downloadLink = document.createElement('a')
          downloadLink.href = linkSource
          downloadLink.download = fileName
          downloadLink.click()
          this.$emit('onFinish')
        }
      })
    }
  }
}
</script>
<style scoped>
.kpr-container {
  max-width: 860px;
}

/* ── Filter bar ── */
.kpr-filter-bar {
  position: sticky;
  top: 64px;
  z-index: 8;
  background: #ffffff;
  padding: 14px 16px;
  border-left: 4px solid #00BCD4;
  border-bottom: 1px solid #EEF2F5;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);
  margin-bottom: 16px;
}

.kpr-filter-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  align-items: center;
}

/* filter-select — isti stil kao na Računima */
.filter-select {
  min-width: 0 !important;
}

.filter-select.v-text-field--outlined >>> fieldset {
  border-color: #B0BEC5 !important;
  border-width: 1.5px !important;
  border-radius: 8px !important;
}

.filter-select.v-text-field--outlined:hover >>> fieldset {
  border-color: #90A4AE !important;
}

.filter-select.v-text-field--outlined.v-input--is-focused >>> fieldset {
  border-color: #00838F !important;
  border-width: 2px !important;
}

.filter-select >>> .v-input__slot {
  background: #ffffff !important;
  min-height: 38px !important;
  max-height: 38px !important;
  padding: 0 8px !important;
  border-radius: 8px !important;
}

.filter-select.v-text-field--outlined >>> .v-input__control {
  height: 38px !important;
  border-radius: 8px !important;
}

.filter-select >>> .v-select__selection,
.filter-select >>> .v-text-field__slot input {
  font-size: 13px !important;
  font-weight: 500 !important;
  color: #263238 !important;
}

.filter-select >>> label {
  font-size: 11px !important;
  font-weight: 500 !important;
  color: #37474F !important;
}

.filter-select >>> .v-input__prepend-inner {
  display: flex !important;
  align-items: center !important;
  align-self: center !important;
  margin-top: 0 !important;
}

.filter-select >>> .v-input__prepend-inner .v-icon {
  color: #00BCD4 !important;
}

/* ── Floating card ── */
.kpr-card {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.07);
  padding: 28px 32px;
}

/* ── Section titles ── */
.kpr-section-title {
  font-size: 12px;
  font-weight: 600;
  color: #64748B;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  padding: 8px 0;
  border-bottom: 1px solid #EEF2F5;
  margin-bottom: 12px;
  margin-top: 8px;
}

.kpr-section-title:first-child {
  margin-top: 0;
}

/* ── Form fields ── */
.kpr-field.v-text-field--outlined >>> fieldset {
  border-color: #E2E8F0 !important;
  border-radius: 8px !important;
}

.kpr-field.v-text-field--outlined:hover >>> fieldset {
  border-color: #94A3B8 !important;
}

.kpr-field.v-text-field--outlined.v-input--is-focused >>> fieldset {
  border-color: #00BCD4 !important;
  border-width: 2px !important;
}

.kpr-field >>> .v-input__slot {
  background: #F8FAFC !important;
  border-radius: 8px !important;
}

.kpr-field >>> label {
  font-size: 13px !important;
  color: #64748B !important;
}

.kpr-field >>> input {
  font-size: 14px !important;
  color: rgba(0, 0, 0, 0.87) !important;
}

/* ── Action row ── */
.kpr-actions {
  display: flex;
  justify-content: flex-end;
  padding-top: 24px;
}

.kpr-generate-btn {
  background: #00BCD4 !important;
  color: #ffffff !important;
  border-radius: 8px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  font-size: 14px !important;
  letter-spacing: 0.3px !important;
  padding: 10px 28px !important;
  height: 42px !important;
  box-shadow: none !important;
}

.kpr-generate-btn:hover {
  background: #00ACC1 !important;
}

.kpr-generate-btn >>> .v-btn__content {
  font-weight: 600 !important;
}
</style>
